var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useDebugValue, } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-use';
export var useFormNavigator = function (_a) {
    var flow = _a.flow, form = _a.form, onComplete = _a.onComplete, exitRoute = _a.exitRoute, fromRoute = _a.fromRoute;
    var pathname = useLocation().pathname;
    var currentIndex = flow.indexOf(pathname || '');
    var currentRoute = flow[currentIndex];
    var nextRoute = flow[currentIndex + 1];
    var previousRoute = flow[currentIndex - 1];
    useDebugValue({
        pathname: pathname,
        currentIndex: currentIndex,
        currentRoute: currentRoute,
        nextRoute: nextRoute,
        previousRoute: previousRoute,
        exitRoute: exitRoute,
        fromRoute: fromRoute,
    });
    var navigate = useNavigate();
    var back = function () {
        if (typeof previousRoute === 'undefined') {
            if (fromRoute)
                navigate(fromRoute);
        }
        navigate(flow[currentIndex - 1]);
    };
    var next = function () {
        if (typeof nextRoute === 'undefined') {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            if (exitRoute)
                navigate(exitRoute);
            return;
        }
        navigate(flow[currentIndex + 1]);
    };
    return {
        back: back,
        next: form.handleSubmit(next),
    };
};
export var FormNavigatorContext = createContext({});
export var useFormNavigatorContext = function () {
    return useContext(FormNavigatorContext);
};
export var FormNavigatorProvider = function (_a) {
    var children = _a.children, formNavigator = __rest(_a, ["children"]);
    return (_jsx(FormNavigatorContext.Provider, __assign({ value: formNavigator }, { children: children })));
};
